import React from "react";

export const IconCircleCheck = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0001 0.666687C6.64008 0.666687 0.666748 6.64002 0.666748 14C0.666748 21.36 6.64008 27.3334 14.0001 27.3334C21.3601 27.3334 27.3334 21.36 27.3334 14C27.3334 6.64002 21.3601 0.666687 14.0001 0.666687ZM14.0001 24.6667C8.12008 24.6667 3.33341 19.88 3.33341 14C3.33341 8.12002 8.12008 3.33335 14.0001 3.33335C19.8801 3.33335 24.6667 8.12002 24.6667 14C24.6667 19.88 19.8801 24.6667 14.0001 24.6667Z"
      fill="white"
    />
    <path
      d="M20.12 8.10669L11.3333 16.8934L7.88 13.4534L6 15.3334L11.3333 20.6667L22 10L20.12 8.10669Z"
      fill="white"
    />
  </svg>
);

export const GiftIcon = () => (
  <svg
    width="58"
    height="58"
    viewBox="0 0 58 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.575 14.8333C9.64511 13.3129 9.16675 11.4414 9.16675 9.16663C9.16675 4.6817 12.5394 0.666626 17.6667 0.666626C22.8007 0.666626 26.941 4.10524 29.0001 9.48914C31.0592 4.10524 35.1994 0.666626 40.3334 0.666626C45.4608 0.666626 48.8334 4.6817 48.8334 9.16663C48.8334 11.4414 48.355 13.3129 47.4251 14.8333H51.6668C54.7964 14.8333 57.3334 17.3703 57.3334 20.5V26.1666C57.3334 29.2962 54.7964 31.8333 51.6668 31.8333V51.6666C51.6668 54.7962 49.1297 57.3333 46.0001 57.3333H12.0001C8.87047 57.3333 6.33342 54.7962 6.33342 51.6666V31.8333C3.2038 31.8333 0.666748 29.2962 0.666748 26.1666V20.5C0.666748 17.3703 3.2038 14.8333 6.33342 14.8333H10.575ZM26.1667 20.5H6.33342V26.1666H26.1667V20.5ZM51.6667 26.1666H31.8334V20.5H51.6667V26.1666ZM26.1667 51.6666V31.8333H12.0001V51.6666H26.1667ZM46.0001 51.6666H31.8334V31.8333H46.0001V51.6666ZM17.6667 6.33329C15.9091 6.33329 14.8334 7.61385 14.8334 9.16663C14.8334 12.7174 17.7149 14.4058 24.5501 14.761C23.7904 9.48282 20.9596 6.33329 17.6667 6.33329ZM33.2501 14.761C34.0097 9.48282 36.8406 6.33329 40.1334 6.33329C41.8911 6.33329 42.9668 7.61385 42.9668 9.16663C42.9668 12.7174 40.0853 14.4058 33.2501 14.761Z"
      fill="#4E4E5A"
    />
  </svg>
);

export const CheckGold = () => (
  <svg
    width="17"
    height="13"
    viewBox="0 0 17 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.70711 9.29289L15 0L16.4142 1.41421L5.70711 12.1213L0 6.41421L1.41421 5L5.70711 9.29289Z"
      fill="#FEC669"
    />
  </svg>
);

export const CheckViolet = () => (
  <svg
    width="23"
    height="17"
    viewBox="0 0 23 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.94273 13.057L20.3333 0.666504L22.2189 2.55212L7.94273 16.8283L0.333252 9.21879L2.21887 7.33317L7.94273 13.057Z"
      fill="#5448DB"
    />
  </svg>
);

export const TextDivider = () => (
  <svg
    width="1"
    height="24"
    viewBox="0 0 1 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      opacity="0.25"
      x1="0.5"
      y1="-2.18557e-08"
      x2="0.500001"
      y2="24"
      stroke="#595959"
    />
  </svg>
);

export const ChevronRight = () => (
  <svg
    width="9"
    height="14"
    viewBox="0 0 9 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.58586 7.00008L0.292969 1.70718L1.70718 0.292969L8.41429 7.00008L1.70718 13.7072L0.292969 12.293L5.58586 7.00008Z"
      fill="#E8E8E8"
    />
  </svg>
);

export const QuizIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="#9A91FF" fillOpacity="0.15" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 14.9443H33C34.1046 14.9443 35 15.8232 35 16.9073V30.648C35 31.7322 34.1046 32.611 33 32.611H15C13.8954 32.611 13 31.7322 13 30.648V16.9073C13 15.8232 13.8954 14.9443 15 14.9443ZM15 16.9073V30.648H33V16.9073H15ZM19 28.6851H21V22.7962H19V28.6851ZM25 28.6851H23V18.8703H25V28.6851ZM27 28.6851H29V21.8147H27V28.6851Z"
      fill="#675BF5"
    />
  </svg>
);

export const SignoutIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.70421 9.70711L13.9971 3.41421V7H15.9971V0H8.9971V2H12.5829L6.28999 8.29289L7.70421 9.70711ZM15 14V10H13V14H2V3H6V1H2C0.89543 1 0 1.89543 0 3V14C0 15.1046 0.89543 16 2 16H13C14.1046 16 15 15.1046 15 14Z"
      fill="#595959"
    />
  </svg>
);

export const SettingsIcon = () => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0C8.69378 0 7.58254 0.834808 7.17071 2H0V4H7.17071C7.58254 5.16519 8.69378 6 10 6C11.6569 6 13 4.65685 13 3C13 1.34315 11.6569 0 10 0ZM5 6C3.69378 6 2.58254 6.83481 2.17071 8H0V10H2.17071C2.58254 11.1652 3.69378 12 5 12C6.65685 12 8 10.6569 8 9C8 7.34315 6.65685 6 5 6ZM9 8H16V10H9V8ZM6 9C6 9.55229 5.55228 10 5 10C4.44772 10 4 9.55229 4 9C4 8.44771 4.44772 8 5 8C5.55228 8 6 8.44771 6 9ZM14 2H16V4H14V2ZM11 3C11 3.55228 10.5523 4 10 4C9.44771 4 9 3.55228 9 3C9 2.44772 9.44771 2 10 2C10.5523 2 11 2.44772 11 3Z"
      fill="#595959"
    />
  </svg>
);

export const GearIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4374 13.9313L13.9155 12.4532L13.3949 10.562L13.6217 10.0203L15.3333 9.05451V6.96426L13.6266 5.99445L13.4036 5.45374L13.9307 3.56153L12.4516 2.08451L10.5601 2.60495L10.0197 2.37834L9.05384 0.666626H6.96358L5.99377 2.37332L5.45319 2.59627L3.56128 2.0685L2.08443 3.54535L2.60495 5.43708L2.37834 5.97752L0.666626 6.94339V9.03304L2.37178 10.005L2.59497 10.5462L2.06794 12.4381L3.54535 13.9155L5.43708 13.395L5.97758 13.6216L6.94347 15.3326H9.03319L10.0044 13.6274L10.5455 13.4043L12.4374 13.9313ZM12.5684 9.0837L11.9872 10.4718L12.4241 12.059L12.0452 12.4379L10.4613 11.9967L9.0726 12.5695L8.25818 13.9993H7.7219L6.91423 12.5685L5.52766 11.9872L3.9396 12.4241L3.56131 12.0458L4.00253 10.462L3.42984 9.07338L1.99996 8.25833V7.72198L3.43136 6.91429L4.01276 5.52766L3.57579 3.9396L3.9533 3.5621L5.53713 4.00393L6.92632 3.43099L7.7395 1.99996H8.27524L9.08293 3.43136L10.4696 4.01276L12.0579 3.57571L12.4372 3.9544L11.996 5.53793L12.5689 6.927L14 7.74017V8.27591L12.5684 9.0837ZM7.99996 10.6666C6.5272 10.6666 5.33329 9.47272 5.33329 7.99996C5.33329 6.5272 6.5272 5.33329 7.99996 5.33329C9.47272 5.33329 10.6666 6.5272 10.6666 7.99996C10.6666 9.47272 9.47272 10.6666 7.99996 10.6666ZM9.33329 7.99996C9.33329 8.73634 8.73634 9.33329 7.99996 9.33329C7.26358 9.33329 6.66663 8.73634 6.66663 7.99996C6.66663 7.26358 7.26358 6.66663 7.99996 6.66663C8.73634 6.66663 9.33329 7.26358 9.33329 7.99996Z"
      fill="#595959"
    />
  </svg>
);

export const Reits101Icon = () => (
  <svg
    width="28"
    height="22"
    viewBox="0 0 28 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.666748 3.00016C0.666748 4.47292 1.86066 5.66683 3.33341 5.66683C4.80617 5.66683 6.00008 4.47292 6.00008 3.00016C6.00008 1.5274 4.80617 0.333496 3.33341 0.333496C1.86066 0.333496 0.666748 1.5274 0.666748 3.00016ZM27.3334 1.66683V4.3335H8.66675V1.66683H27.3334ZM27.3334 12.3335V9.66683H8.66675V12.3335H27.3334ZM8.66675 20.3335H27.3334V17.6668H8.66675V20.3335ZM0.666748 19.0002C0.666748 20.4729 1.86066 21.6668 3.33341 21.6668C4.80617 21.6668 6.00008 20.4729 6.00008 19.0002C6.00008 17.5274 4.80617 16.3335 3.33341 16.3335C1.86066 16.3335 0.666748 17.5274 0.666748 19.0002ZM3.33341 13.6668C1.86066 13.6668 0.666748 12.4729 0.666748 11.0002C0.666748 9.5274 1.86066 8.3335 3.33341 8.3335C4.80617 8.3335 6.00008 9.5274 6.00008 11.0002C6.00008 12.4729 4.80617 13.6668 3.33341 13.6668Z"
      fill="#121324"
    />
  </svg>
);

export const ScreenerIcon = () => (
  <svg
    width="18"
    height="13"
    viewBox="0 0 18 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.75 0H15.75C16.5784 0 17.25 0.671573 17.25 1.5V11.25C17.25 12.0784 16.5784 12.75 15.75 12.75H6.75H5.25H2.25C1.42157 12.75 0.75 12.0784 0.75 11.25V1.5C0.75 0.671573 1.42157 0 2.25 0H5.25H6.75ZM5.25 1.5H2.25V3.75H5.25V1.5ZM6.75 3.75V1.5H15.75V3.75H6.75ZM5.25 5.25H2.25V7.5H5.25V5.25ZM6.75 7.5V5.25H15.75V7.5H6.75ZM5.25 9H2.25V11.25H5.25V9ZM6.75 11.25V9H15.75V11.25H6.75Z"
      fill="#BFBFBF"
    />
  </svg>
);

export const WatchlistIcon = () => (
  <svg
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00002 0C11.0457 0 13.0018 1.07297 14.8247 2.83586C15.4466 3.43729 16.0093 4.07937 16.5046 4.72172C16.8035 5.10933 17.0157 5.41425 17.1318 5.5959L17.3903 6L17.1318 6.4041C17.0157 6.58575 16.8035 6.89067 16.5046 7.27828C16.0093 7.92063 15.4466 8.56271 14.8247 9.16414C13.0018 10.927 11.0457 12 9.00002 12C6.95436 12 4.99826 10.927 3.1753 9.16414C2.55339 8.56271 1.99075 7.92063 1.49545 7.27828C1.19657 6.89067 0.984373 6.58575 0.868191 6.4041L0.609741 6L0.868191 5.5959C0.984373 5.41425 1.19657 5.10933 1.49545 4.72172C1.99075 4.07937 2.55339 3.43729 3.1753 2.83586C4.99826 1.07297 6.95436 0 9.00002 0ZM15.3167 5.63766C14.8632 5.04954 14.3476 4.46115 13.782 3.91414C12.2119 2.39578 10.5788 1.5 9.00002 1.5C7.42121 1.5 5.78814 2.39578 4.21805 3.91414C3.6524 4.46115 3.13681 5.04954 2.68333 5.63766C2.58539 5.76468 2.49488 5.88587 2.41214 6C2.49488 6.11413 2.58539 6.23532 2.68333 6.36234C3.13681 6.95046 3.6524 7.53885 4.21805 8.08586C5.78814 9.60422 7.42121 10.5 9.00002 10.5C10.5788 10.5 12.2119 9.60422 13.782 8.08586C14.3476 7.53885 14.8632 6.95046 15.3167 6.36234C15.4146 6.23532 15.5052 6.11413 15.5879 6C15.5052 5.88587 15.4146 5.76468 15.3167 5.63766ZM6.00002 6C6.00002 7.65685 7.34316 9 9.00002 9C10.6569 9 12 7.65685 12 6C12 4.34315 10.6569 3 9.00002 3C7.34316 3 6.00002 4.34315 6.00002 6ZM10.5 6C10.5 6.82843 9.82844 7.5 9.00002 7.5C8.17159 7.5 7.50002 6.82843 7.50002 6C7.50002 5.17157 8.17159 4.5 9.00002 4.5C9.82844 4.5 10.5 5.17157 10.5 6Z"
      fill="#BFBFBF"
    />
  </svg>
);

export const QuestionMarkIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM12 18.0938C11.482 18.0938 11.0625 17.6742 11.0625 17.1562C11.0625 16.6383 11.482 16.2188 12 16.2188C12.518 16.2188 12.9375 16.6383 12.9375 17.1562C12.9375 17.6742 12.518 18.0938 12 18.0938ZM13.4742 12.9492C13.262 13.0312 13.0793 13.1752 12.9501 13.3625C12.821 13.5498 12.7512 13.7717 12.75 13.9992V14.5312C12.75 14.6344 12.6656 14.7188 12.5625 14.7188H11.4375C11.3344 14.7188 11.25 14.6344 11.25 14.5312V14.0273C11.25 13.4859 11.407 12.9516 11.7164 12.5062C12.0188 12.0703 12.4406 11.7375 12.9375 11.5477C13.7344 11.2406 14.25 10.5727 14.25 9.84375C14.25 8.81016 13.2398 7.96875 12 7.96875C10.7602 7.96875 9.75 8.81016 9.75 9.84375V10.0219C9.75 10.125 9.66562 10.2094 9.5625 10.2094H8.4375C8.33437 10.2094 8.25 10.125 8.25 10.0219V9.84375C8.25 8.92266 8.65312 8.0625 9.38437 7.42266C10.0875 6.80625 11.0156 6.46875 12 6.46875C12.9844 6.46875 13.9125 6.80859 14.6156 7.42266C15.3469 8.0625 15.75 8.92266 15.75 9.84375C15.75 11.1984 14.857 12.4172 13.4742 12.9492Z"
      fill="#BFBFBF"
    />
  </svg>
);

export const ChevronTop = () => (
  <svg
    width="18"
    height="11"
    viewBox="0 0 18 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00008 3.41421L1.70718 10.7071L0.292969 9.29289L9.00008 0.585785L17.7072 9.29289L16.293 10.7071L9.00008 3.41421Z"
      fill="#BFBFBF"
    />
  </svg>
);

export const ChevronBottom = () => (
  <svg
    width="18"
    height="11"
    viewBox="0 0 18 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.293 0.292908L17.7072 1.70712L9.00008 10.4142L0.292969 1.70712L1.70718 0.292908L9.00008 7.5858L16.293 0.292908Z"
      fill="#BFBFBF"
    />
  </svg>
);

export const ChevronBottonMenu = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.293 4.29297L14.7072 5.70718L8.00008 12.4143L1.29297 5.70718L2.70718 4.29297L8.00008 9.58586L13.293 4.29297Z"
      fill="#BFBFBF"
    />
  </svg>
);

export const TuneStrategyIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="#C9C4FF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 15C15.1362 15 13.5701 13.7252 13.126 12H6V10H13.126C13.5701 8.27477 15.1362 7 17 7C19.2091 7 21 8.79086 21 11C21 13.2091 19.2091 15 17 15ZM23 10H26V12H23V10ZM12 25C10.1362 25 8.57006 23.7252 8.12602 22H6V20H8.12602C8.57006 18.2748 10.1362 17 12 17C14.2091 17 16 18.7909 16 21C16 23.2091 14.2091 25 12 25ZM18 22H26V20H18V22ZM14 21C14 22.1046 13.1046 23 12 23C10.8954 23 10 22.1046 10 21C10 19.8954 10.8954 19 12 19C13.1046 19 14 19.8954 14 21ZM19 11C19 12.1046 18.1046 13 17 13C15.8954 13 15 12.1046 15 11C15 9.89543 15.8954 9 17 9C18.1046 9 19 9.89543 19 11Z"
      fill="#5448DB"
    />
  </svg>
);

export const CloseCircleIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 17.25C4.44365 17.25 0.75 13.5563 0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25ZM9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75ZM6.53033 12.5303L9 10.0607L11.4697 12.5303L12.5303 11.4697L10.0607 9L12.5303 6.53033L11.4697 5.46967L9 7.93934L6.53033 5.46967L5.46967 6.53033L7.93934 9L5.46967 11.4697L6.53033 12.5303Z"
      fill="#BFBFBF"
    />
  </svg>
);

export const LockIcon = () => (
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.25 4.25V6.5H1.5C0.698736 6.5 0 7.08228 0 7.875V14.125C0 14.9177 0.698736 15.5 1.5 15.5H10.5C11.3013 15.5 12 14.9177 12 14.125V7.875C12 7.08228 11.3013 6.5 10.5 6.5H9.75V4.25C9.75 2.17893 8.07107 0.5 6 0.5C3.92893 0.5 2.25 2.17893 2.25 4.25ZM8.25 4.25V6.5H3.75V4.25C3.75 3.00736 4.75736 2 6 2C7.24264 2 8.25 3.00736 8.25 4.25ZM1.5 14V8H10.5V14H1.5ZM6.75 11C6.75 11.4142 6.41421 11.75 6 11.75C5.58579 11.75 5.25 11.4142 5.25 11C5.25 10.5858 5.58579 10.25 6 10.25C6.41421 10.25 6.75 10.5858 6.75 11Z"
      fill="#675BF5"
    />
  </svg>
);

export const LockIconCircle = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="28" cy="28" r="28" fill="#9A91FF" fillOpacity="0.23" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0833 20.0833V24.8333H18.5C16.8084 24.8333 15.3333 26.0626 15.3333 27.7361V40.9305C15.3333 42.604 16.8084 43.8333 18.5 43.8333H37.5C39.1915 43.8333 40.6666 42.604 40.6666 40.9305V27.7361C40.6666 26.0626 39.1915 24.8333 37.5 24.8333H35.9166V20.0833C35.9166 15.711 32.3722 12.1666 28 12.1666C23.6277 12.1666 20.0833 15.711 20.0833 20.0833ZM32.75 20.0833V24.8333H23.25V20.0833C23.25 17.4599 25.3766 15.3333 28 15.3333C30.6233 15.3333 32.75 17.4599 32.75 20.0833ZM18.5 40.6666V28H37.5V40.6666H18.5ZM29.5833 34.3333C29.5833 35.2077 28.8744 35.9166 28 35.9166C27.1255 35.9166 26.4166 35.2077 26.4166 34.3333C26.4166 33.4588 27.1255 32.75 28 32.75C28.8744 32.75 29.5833 33.4588 29.5833 34.3333Z"
      fill="#675BF5"
    />
  </svg>
);

export const ModalCloseIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00008 9.41423L3.70718 13.7071L2.29297 12.2929L6.58586 8.00001L2.29297 3.70712L3.70718 2.29291L8.00008 6.5858L12.293 2.29291L13.7072 3.70712L9.41429 8.00001L13.7072 12.2929L12.293 13.7071L8.00008 9.41423Z"
      fill="#595959"
    />
  </svg>
);

export const PremiumStrategyIcon = () => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="19" cy="19" r="19" fill="#FEC669" />
    <g opacity="0.7">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1696 21.894L11.7934 29.918L18.9994 26.1296L26.2054 29.918L24.8291 21.894L30.6589 16.2114L22.6024 15.0407L18.9994 7.74023L15.3964 15.0407L7.33984 16.2114L13.1696 21.894ZM22.6802 21.1958L23.5491 26.2619L18.9994 23.87L14.4496 26.2619L15.3186 21.1958L11.6378 17.6079L16.7245 16.8687L18.9994 12.2593L21.2742 16.8687L26.361 17.6079L22.6802 21.1958Z"
        fill="#873800"
      />
    </g>
  </svg>
);

export const ConservativeIcon = () => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="19" cy="19" r="19" fill="#9A91FF" fillOpacity="0.23" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 20C7.44772 20 7 19.5523 7 19C7 18.4477 7.44772 18 8 18H8.41604C9.1876 16.2341 10.9497 15 13 15C14.8244 15 16.4206 15.9771 17.2938 17.4366C17.7845 17.158 18.3765 17 19 17C19.6235 17 20.2155 17.158 20.7062 17.4366C21.5794 15.9771 23.1756 15 25 15C27.0503 15 28.8124 16.2341 29.584 18H30C30.5523 18 31 18.4477 31 19C31 19.5523 30.5523 20 30 20C30 22.7614 27.7614 25 25 25C22.2386 25 20 22.7614 20 20C20 19.8313 20.0084 19.6645 20.0247 19.5H20C20 19.2966 19.6046 19 19 19C18.3954 19 18 19.2966 18 19.5H17.9753C17.9916 19.6645 18 19.8313 18 20C18 22.7614 15.7614 25 13 25C10.2386 25 8 22.7614 8 20ZM13 23C14.6569 23 16 21.6569 16 20C16 18.3431 14.6569 17 13 17C11.3431 17 10 18.3431 10 20C10 21.6569 11.3431 23 13 23ZM28 20C28 21.6569 26.6569 23 25 23C23.3431 23 22 21.6569 22 20C22 18.3431 23.3431 17 25 17C26.6569 17 28 18.3431 28 20Z"
      fill="#675BF5"
    />
  </svg>
);

export const DefensiveIcon = () => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="19" cy="19" r="19" fill="#9A91FF" fillOpacity="0.23" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 22C10 24.6604 13 27.3271 19 30C25 27.3333 28 24.6667 28 22C28 21.6186 28.0017 20.8033 28.0038 19.7947C28.01 16.8371 28.0197 12.2172 28 12C28 11.2324 27.7054 11.054 26.8901 10.5603C26.6432 10.4108 26.3486 10.2324 26 10C24.5 9 21.9952 8 19 8C15.5632 8 12.1618 9.89214 12 10C11.6514 10.2324 11.3568 10.4108 11.1099 10.5603C10.2946 11.054 10 11.2324 10 12V22ZM26.0018 20.7547C26.0006 21.3838 26 21.7697 26 22C26 23.5142 23.7722 25.5737 19.0009 27.802C14.2291 25.5687 12 23.5085 12 22V12.3633C12.0402 12.3384 12.0831 12.3118 12.1278 12.284C12.4512 12.0834 12.8726 11.8219 13.1094 11.6641C14.0286 11.0513 16.8381 10 19 10C21.2602 10 23.4143 10.6799 24.8906 11.6641C25.1274 11.8219 25.5488 12.0834 25.8722 12.284C25.9205 12.314 25.9666 12.3426 26.0096 12.3693C26.0117 12.9618 26.0127 14.8776 26.009 17.1098C26.0082 17.6272 26.0072 18.1695 26.0059 18.8014L26.0018 20.7547Z"
      fill="#675BF5"
    />
  </svg>
);

export const BalancedIcon = () => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="19" cy="19" r="19" fill="#9A91FF" fillOpacity="0.23" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 13H13V9H15V13ZM15 29V19H16C17.1046 19 18 18.1046 18 17V16C18 14.8954 17.1046 14 16 14H12C10.8954 14 10 14.8954 10 16V17C10 18.1046 10.8954 19 12 19H13V29H15ZM25 29V24H26C27.1046 24 28 23.1046 28 22V21C28 19.8954 27.1046 19 26 19H22C20.8954 19 20 19.8954 20 21V22C20 23.1046 20.8954 24 22 24H23V29H25ZM23 18H25V9H23V18ZM12 16V17H16V16H12ZM22 22V21H26V22H22Z"
      fill="#675BF5"
    />
  </svg>
);

export const GrowthIcon = () => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="19" cy="19" r="19" fill="#9A91FF" fillOpacity="0.23" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 10H28C29.1046 10 30 10.8954 30 12V26C30 27.1046 29.1046 28 28 28H10C8.89543 28 8 27.1046 8 26V12C8 10.8954 8.89543 10 10 10ZM10 12V26H28V12H10ZM14 24H16V18H14V24ZM20 24H18V14H20V24ZM22 24H24V17H22V24Z"
      fill="#675BF5"
    />
  </svg>
);

export const AggressiveIcon = () => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="19" cy="19" r="19" fill="#9A91FF" fillOpacity="0.23" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1752 18.5302C18.7216 17.7633 18.6606 16.9555 18.2817 15.5026C17.5323 12.6291 17.8307 11.0541 20.4141 9.18941L21.675 8.2793L21.9799 9.80413C22.304 11.4247 22.8363 12.427 24.2029 14.3549C24.2572 14.4315 24.2572 14.4315 24.3118 14.5084C26.2803 17.2857 26.9993 18.9599 26.9993 22.0002C26.9993 25.6886 23.2707 29.0002 18.9993 29.0002C14.7278 29.0002 10.9993 25.6891 10.9993 22.0002C10.9993 21.9313 10.9994 21.9334 10.9877 21.6287C10.8974 19.2721 11.3332 17.4276 13.0964 15.4361C13.469 15.0153 13.8924 14.6109 14.369 14.224L15.421 13.3697L15.927 14.6268C16.3009 15.5557 16.739 16.2859 17.234 16.8218C17.6531 17.2756 17.9641 17.8463 18.1752 18.5302ZM14.5938 16.7619C13.2365 18.295 12.9138 19.6609 12.9863 21.5521C12.9998 21.9041 12.9993 21.8918 12.9993 22.0002C12.9993 24.5281 15.7829 27.0002 18.9993 27.0002C22.2155 27.0002 24.9993 24.5277 24.9993 22.0002C24.9993 19.4585 24.4311 18.1353 22.6801 15.6649C22.6258 15.5884 22.6258 15.5884 22.5713 15.5115C21.5079 14.0114 20.874 12.9678 20.4547 11.8008C19.7698 12.6214 19.8101 13.4376 20.217 14.9979C20.9664 17.8714 20.668 19.4464 18.0846 21.3111L16.6116 22.3743L16.5012 20.561C16.4306 19.4025 16.1684 18.6158 15.7647 18.1787C15.3659 17.7469 15.0058 17.2414 14.6829 16.663C14.6528 16.6959 14.6231 16.7289 14.5938 16.7619Z"
      fill="#675BF5"
    />
  </svg>
);

export const WelcomeIcon = () => (
  <svg
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="48" cy="48" r="48" fill="#9A91FF" fillOpacity="0.06" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.4437 63.5564C30.5952 61.7079 30.0649 58.8884 30.6446 55.1888C27.6188 52.9828 26 50.6141 26 48C26 45.3859 27.6188 43.0172 30.6446 40.8112C30.0649 37.1116 30.5952 34.2921 32.4437 32.4437C34.2921 30.5952 37.1116 30.0649 40.8112 30.6446C43.0172 27.6188 45.3859 26 48 26C50.6141 26 52.9828 27.6188 55.1888 30.6446C58.8884 30.0649 61.7079 30.5952 63.5564 32.4437C65.4048 34.2921 65.9351 37.1116 65.3554 40.8112C68.3812 43.0172 70 45.3859 70 48C70 50.6141 68.3812 52.9828 65.3554 55.1888C65.9351 58.8884 65.4048 61.7079 63.5564 63.5564C61.7079 65.4048 58.8884 65.9351 55.1888 65.3554C52.9828 68.3812 50.6141 70 48 70C45.3859 70 43.0172 68.3812 40.8112 65.3554C37.1116 65.9351 34.2921 65.4048 32.4437 63.5564ZM41.3052 61.196C42.117 61.0221 42.9519 61.3679 43.403 62.0649C45.1645 64.7866 46.7353 66 48 66C49.2647 66 50.8355 64.7866 52.597 62.0649C53.0481 61.3679 53.883 61.0221 54.6948 61.196C57.8649 61.8749 59.8336 61.6222 60.7279 60.7279C61.6222 59.8336 61.8749 57.8649 61.196 54.6948C61.0221 53.883 61.3679 53.0481 62.0649 52.597C64.7866 50.8355 66 49.2647 66 48C66 46.7353 64.7866 45.1645 62.0649 43.403C61.3679 42.9519 61.0221 42.117 61.196 41.3052C61.8749 38.1351 61.6222 36.1664 60.7279 35.2721C59.8336 34.3778 57.8649 34.1251 54.6948 34.804C53.883 34.9779 53.0481 34.6321 52.597 33.9351C50.8355 31.2134 49.2647 30 48 30C46.7353 30 45.1645 31.2134 43.403 33.9351C42.9519 34.6321 42.117 34.9779 41.3052 34.804C38.1351 34.1251 36.1664 34.3778 35.2721 35.2721C34.3778 36.1664 34.1251 38.1351 34.804 41.3052C34.9779 42.117 34.6321 42.9519 33.9351 43.403C31.2134 45.1645 30 46.7353 30 48C30 49.2647 31.2134 50.8355 33.9351 52.597C34.6321 53.0481 34.9779 53.883 34.804 54.6948C34.1251 57.8649 34.3778 59.8336 35.2721 60.7279C36.1664 61.6222 38.1351 61.8749 41.3052 61.196ZM54.5858 40.5858L46 49.1716L41.4142 44.5858L38.5858 47.4142L46 54.8284L57.4142 43.4142L54.5858 40.5858Z"
      fill="#675BF5"
    />
  </svg>
);

export const FreeGiftIcon = () => (
  <svg
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="48" cy="48" r="48" fill="#9A91FF" fillOpacity="0.06" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.9941 38C34.3377 36.9268 34 35.6057 34 34C34 30.8342 36.3807 28 40 28C43.624 28 46.5465 30.4273 48 34.2277C49.4535 30.4273 52.376 28 56 28C59.6193 28 62 30.8342 62 34C62 35.6057 61.6623 36.9268 61.0059 38H64C66.2091 38 68 39.7909 68 42V46C68 48.2091 66.2091 50 64 50V64C64 66.2091 62.2091 68 60 68H36C33.7909 68 32 66.2091 32 64V50C29.7909 50 28 48.2091 28 46V42C28 39.7909 29.7909 38 32 38H34.9941ZM46 42H32V46H46V42ZM64 46H50V42H64V46ZM46 64V50H36V64H46ZM60 64H50V50H60V64ZM40 32C38.7593 32 38 32.9039 38 34C38 36.5065 40.034 37.6982 44.8588 37.949C44.3226 34.2232 42.3244 32 40 32ZM51 37.949C51.5362 34.2232 53.5345 32 55.8588 32C57.0995 32 57.8588 32.9039 57.8588 34C57.8588 36.5065 55.8248 37.6982 51 37.949Z"
      fill="#675BF5"
    />
  </svg>
);

export const ReadyIcon = () => (
  <svg
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="48" cy="48" r="48" fill="#9A91FF" fillOpacity="0.06" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M53.2383 36L37.0918 52.3998L30.7089 45.8999L27.9473 48.7L37.0918 58L55.9999 38.8001L53.2383 36ZM45.3328 54.1886L49.0918 58L67.9999 38.8001L65.2383 36L49.0918 52.3998L48.0924 51.3865L45.3328 54.1886Z"
      fill="#675BF5"
    />
  </svg>
);

export const EyeIcon = () => (
  <svg
    width="25"
    height="16"
    viewBox="0 0 25 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.507 0C15.447 0 18.2583 1.43062 20.8782 3.78115C21.772 4.58305 22.5806 5.43916 23.2925 6.29562C23.722 6.81244 24.027 7.21899 24.1939 7.4612L24.5654 8L24.1939 8.5388C24.027 8.781 23.722 9.18756 23.2925 9.70438C22.5806 10.5608 21.772 11.417 20.8782 12.2189C18.2583 14.5694 15.447 16 12.507 16C9.56696 16 6.75568 14.5694 4.13574 12.2189C3.24193 11.417 2.43332 10.5608 1.72148 9.70438C1.29193 9.18756 0.986964 8.781 0.819989 8.5388L0.448547 8L0.819989 7.4612C0.986964 7.21899 1.29193 6.81244 1.72148 6.29562C2.43332 5.43916 3.24193 4.58305 4.13574 3.78115C6.75568 1.43062 9.56696 0 12.507 0ZM21.5852 7.51688C20.9335 6.73272 20.1925 5.9482 19.3796 5.21885C17.123 3.19438 14.776 2 12.507 2C10.2379 2 7.89088 3.19438 5.63437 5.21885C4.82142 5.9482 4.08042 6.73272 3.42868 7.51688C3.28793 7.68624 3.15785 7.84782 3.03894 8C3.15785 8.15218 3.28793 8.31376 3.42868 8.48312C4.08042 9.26728 4.82142 10.0518 5.63437 10.7811C7.89088 12.8056 10.2379 14 12.507 14C14.776 14 17.123 12.8056 19.3796 10.7811C20.1925 10.0518 20.9335 9.26728 21.5852 8.48312C21.726 8.31376 21.8561 8.15218 21.975 8C21.8561 7.84782 21.726 7.68624 21.5852 7.51688ZM8.1954 8C8.1954 10.2091 10.1258 12 12.507 12C14.8882 12 16.8185 10.2091 16.8185 8C16.8185 5.79086 14.8882 4 12.507 4C10.1258 4 8.1954 5.79086 8.1954 8ZM14.6627 8C14.6627 9.10457 13.6976 10 12.507 10C11.3164 10 10.3512 9.10457 10.3512 8C10.3512 6.89543 11.3164 6 12.507 6C13.6976 6 14.6627 6.89543 14.6627 8Z"
      fill="#675BF5"
    />
  </svg>
);

export const TailoredIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="#9A91FF" fillOpacity="0.16" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 32V30H20V31C20 32.1046 20.8954 33 22 33H25C26.1046 33 27 32.1046 27 31V29H30V30C30 31.1046 30.8954 32 32 32H34C35.1046 32 36 31.1046 36 30V16C36 14.8954 35.1046 14 34 14H16H14C12.8954 14 12 14.8954 12 16V32C12 33.1046 12.8954 34 14 34H16C17.1046 34 18 33.1046 18 32ZM14 32V16H32H34V30H32V26H30V27H27V26H25V31H22V26H20V28H18V26H16V32H14ZM31 18V20H17V18H31ZM28 24V22H17V24H28Z"
      fill="#675BF5"
    />
  </svg>
);

export const GlobalIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="#9A91FF" fillOpacity="0.16" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 13C30.0751 13 35 17.9249 35 24C35 30.0751 30.0751 35 24 35C17.9249 35 13 30.0751 13 24C13 17.9249 17.9249 13 24 13ZM15.0656 22.9074C15.3572 23.2805 16.1678 23.758 17.4083 24.1475C17.8967 24.3009 18.4316 24.4357 19.0056 24.5502C19.0019 24.3679 19 24.1844 19 24C19 20.6724 19.6056 17.6673 20.6545 15.6423C17.6641 16.8404 15.4663 19.597 15.0656 22.9074ZM19.1291 26.6108C17.5233 26.3317 16.1464 25.9093 15.103 25.3658C15.5884 28.5542 17.7468 31.1927 20.6546 32.3577C19.8887 30.8792 19.3592 28.8783 19.1291 26.6108ZM21.1789 26.8773C22.076 26.9581 23.0209 27 24 27C24.9633 27 25.9124 26.9454 26.8253 26.8441C26.3742 30.4417 25.127 33 24 33C22.8765 33 21.6335 30.4574 21.1789 26.8773ZM26.9863 24.8045C26.0367 24.9275 25.028 25 24 25C22.9558 25 21.9534 24.9483 21.0153 24.8502C21.0052 24.5706 21 24.287 21 24C21 18.984 22.5936 15 24 15C25.4064 15 27 18.984 27 24C27 24.2713 26.9953 24.5397 26.9863 24.8045ZM28.8792 26.5269C28.6539 28.8289 28.1208 30.861 27.3454 32.3577C30.3046 31.1721 32.4876 28.4606 32.9212 25.1964C31.861 25.7479 30.4647 26.209 28.8792 26.5269ZM32.9285 22.8601C32.458 23.3883 30.9737 24.0157 28.9962 24.4541C28.9987 24.3035 29 24.1521 29 24C29 20.6724 28.3944 17.6673 27.3454 15.6423C30.3216 16.8347 32.5128 19.5708 32.9285 22.8601Z"
      fill="#675BF5"
    />
  </svg>
);
export const EduIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="#9A91FF" fillOpacity="0.16" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4077 19.4689L22.2427 14.1023C22.9427 13.7289 23.7827 13.7289 24.4827 14.1023L35.5894 20.1573C35.9627 20.3673 36.196 20.7523 36.196 21.1839V28.6623C36.196 29.3039 35.671 29.8289 35.0294 29.8289C34.3877 29.8289 33.8627 29.3039 33.8627 28.6623V21.7673L24.4827 26.8889C23.7827 27.2739 22.9427 27.2739 22.2427 26.8889L12.4077 21.5223C11.6027 21.0789 11.6027 19.9123 12.4077 19.4689ZM15.196 28.6506V25.3723L22.2427 29.2223C22.9427 29.6073 23.7827 29.6073 24.4827 29.2223L31.5294 25.3723V28.6506C31.5294 29.5023 31.0627 30.2956 30.316 30.7039L24.4827 33.8889C23.7827 34.2739 22.9427 34.2739 22.2427 33.8889L16.4094 30.7039C15.6627 30.2956 15.196 29.5023 15.196 28.6506Z"
      fill="#675BF5"
    />
  </svg>
);

export const EduSuccessPay = () => (
  <svg
    width="116"
    height="116"
    viewBox="0 0 116 116"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58 0C25.9939 0 0 25.9938 0 58C0 90.0062 25.9939 116 58 116C90.0061 116 116 90.0062 116 58C116 25.9938 90.0061 0 58 0ZM58 4.46154C87.5949 4.46154 111.538 28.4051 111.538 58C111.538 87.5949 87.5949 111.538 58 111.538C28.4051 111.538 4.46154 87.5949 4.46154 58C4.46154 28.4051 28.4051 4.46154 58 4.46154ZM82.5559 43.0469C82.0522 43.0485 81.5639 43.2205 81.1704 43.5349L47.3341 69.6418L35.2392 54.68C35.0618 54.4343 34.8363 54.2272 34.5763 54.0716C34.3163 53.9159 34.0273 53.8148 33.727 53.7745C33.4267 53.7341 33.1213 53.7554 32.8294 53.837C32.5376 53.9186 32.2654 54.0588 32.0295 54.249C31.7937 54.4393 31.599 54.6756 31.4575 54.9435C31.3159 55.2115 31.2304 55.5055 31.2063 55.8075C31.1821 56.1096 31.2197 56.4134 31.3168 56.7005C31.4139 56.9875 31.5684 57.2518 31.771 57.4772L46.6022 75.8462L83.9065 47.064C84.2825 46.7826 84.5602 46.3897 84.6998 45.9414C84.8395 45.493 84.8341 45.012 84.6845 44.5668C84.5348 44.1217 84.2485 43.7351 83.8663 43.4622C83.4841 43.1893 83.0255 43.0439 82.5559 43.0469Z"
      fill="#52C41A"
    />
  </svg>
);

export const ActionableIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="#9A91FF" fillOpacity="0.16" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23 13H25V15.0549C29.1716 15.5161 32.4839 18.8284 32.9451 23H35V25H32.9451C32.4839 29.1716 29.1716 32.4839 25 32.9451V35H23V32.9451C18.8284 32.4839 15.5161 29.1716 15.0549 25H13V23H15.0549C15.5161 18.8284 18.8284 15.5161 23 15.0549V13ZM17.0709 25H19V23H17.0709C17.5094 19.9343 19.9343 17.5094 23 17.0709V19H25V17.0709C28.0657 17.5094 30.4906 19.9343 30.9291 23H29V25H30.9291C30.4906 28.0657 28.0657 30.4906 25 30.9291V29H23V30.9291C19.9343 30.4906 17.5094 28.0657 17.0709 25ZM22 24C22 25.1046 22.8954 26 24 26C25.1046 26 26 25.1046 26 24C26 22.8954 25.1046 22 24 22C22.8954 22 22 22.8954 22 24Z"
      fill="#675BF5"
    />
  </svg>
);

export const EaseIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="#9A91FF" fillOpacity="0.16" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34 23.999C34 22.3165 32.8696 20.999 31 20.999H27.927L27.9548 20.9233C27.9826 20.8481 28.0609 20.6417 28.137 20.4411L28.1371 20.4409L28.1375 20.4399C28.2046 20.2629 28.2699 20.0907 28.2971 20.0179C28.4872 19.5076 28.626 19.0964 28.7382 18.6892C28.9079 18.0737 29 17.5191 29 16.999C29 15.527 28.0919 14.6127 26.7483 14.2215C26.1423 14.0451 25.6148 13.9989 25 13.999H24.5205L24.2203 14.3729C23.8811 14.7953 23.215 15.5564 22.447 16.434L22.447 16.434C21.0303 18.0529 19.2669 20.0679 18.5704 21.0824C18.3896 21.0287 18.1982 20.9999 18 20.9999H16C14.8954 20.9999 14 21.8953 14 22.9999V31.9999C14 33.1045 14.8954 33.9999 16 33.9999H18C18.6871 33.9999 19.2933 33.6534 19.6534 33.1256C19.9567 33.3218 20.2952 33.4856 20.6631 33.6172C21.5054 33.9186 22.3408 34.0111 23.0344 33.9984L30 33.999C32.7551 33.999 34 29.9426 34 23.999ZM21.3369 31.7341C20.452 31.4175 20 30.9013 20 29.999V22.9999V22.999C20 22.7588 20.0444 22.5461 20.1417 22.319C20.3165 21.911 21.9019 20.1022 23.4047 18.3877L23.4047 18.3877C24.1803 17.5028 24.9338 16.6431 25.46 16.0142C25.7114 16.033 25.9484 16.0717 26.1891 16.1418C26.7622 16.3086 27 16.5481 27 16.999C27 17.3156 26.9359 17.7013 26.8101 18.1576C26.7161 18.4986 26.5944 18.8594 26.4229 19.3197C26.3986 19.385 26.3378 19.5451 26.2733 19.7153L26.2731 19.7158C26.1944 19.9231 26.1102 20.1452 26.079 20.2296C25.9489 20.5812 25.8633 20.8401 25.8047 21.0753C25.5555 22.0754 25.8055 22.999 27 22.999H31C31.6912 22.999 32 23.3589 32 23.999C32 28.7898 31.0151 31.999 30 31.999H23L22.9631 31.9996C22.5254 32.0075 21.9106 31.9394 21.3369 31.7341ZM16 31.9999V22.9999H18V31.9999H16Z"
      fill="#675BF5"
    />
  </svg>
);

export const CustomisableIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="#9A91FF" fillOpacity="0.16" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34 32V25H32V32H16V16H23V14H16C14.8954 14 14 14.8954 14 16V32C14 33.1046 14.8954 34 16 34H32C33.1046 34 34 33.1046 34 32ZM31.1781 14.7234C30.7197 14.2614 30.0921 14 29.4374 14C28.7834 14 28.1564 14.2608 27.6954 14.7246L19.3265 23.0934C18.5787 23.7523 18.0884 24.7328 18.0032 25.7873L18 29.0023V30.0023H22.1346C23.2689 29.9245 24.259 29.4295 24.9575 28.6238L33.279 20.3058C33.7407 19.8442 34.0001 19.218 34.0001 18.5651C34.0001 17.9122 33.7407 17.286 33.279 16.8243L31.1781 14.7234ZM22.064 28.0048C22.5982 27.967 23.0955 27.7184 23.4948 27.2616L29.5567 21.1997L26.8024 18.4453L20.6961 24.5496C20.291 24.9079 20.0403 25.4092 20 25.8678V28.0029L22.064 28.0048ZM28.2169 17.0313L30.9709 19.7855L31.8648 18.8916C31.9514 18.805 32.0001 18.6876 32.0001 18.5651C32.0001 18.4426 31.9514 18.3251 31.8648 18.2385L29.7611 16.1349C29.6755 16.0485 29.5589 16 29.4374 16C29.3158 16 29.1992 16.0485 29.1136 16.1349L28.2169 17.0313Z"
      fill="#675BF5"
    />
  </svg>
);

export const ChartIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.81818 2H20.1818C21.186 2 22 2.99492 22 4.22222V11V13V19.7778C22 21.0051 21.186 22 20.1818 22H3.81818C2.81403 22 2 21.0051 2 19.7778V4.22222C2 2.99492 2.81403 2 3.81818 2ZM20 11V4H4V11H7.41421L9.66269 13.2485L12.7622 6.01627L16.5 11H20ZM4 13H6.58579L10.3373 16.7515L13.2378 9.98373L15.5 13H20V20H4V13Z"
      fill="#675BF5"
    />
  </svg>
);

export const BarChartIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 3H21C22.1046 3 23 3.89543 23 5V19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19V5C1 3.89543 1.89543 3 3 3ZM3 5V19H21V5H3ZM7 17H9V11H7V17ZM13 17H11V7H13V17ZM15 17H17V10H15V17Z"
      fill="#675BF5"
    />
  </svg>
);

export const AccountIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 17.25C4.44365 17.25 0.75 13.5563 0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25ZM14.5496 12.8435C15.3065 11.7527 15.75 10.4282 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 10.4282 2.69354 11.7527 3.45038 12.8435C4.29447 11.7286 6.27795 11.25 9 11.25C11.722 11.25 13.7055 11.7286 14.5496 12.8435ZM13.4735 14.0548C13.254 13.2655 11.677 12.75 9 12.75C6.32296 12.75 4.746 13.2655 4.52649 14.0548C5.71747 15.1096 7.28395 15.75 9 15.75C10.716 15.75 12.2825 15.1096 13.4735 14.0548ZM9 4.5C7.18432 4.5 6 5.81682 6 7.5C6 10.0705 7.32065 11.25 9 11.25C10.6636 11.25 12 10.1097 12 7.65C12 5.94118 10.8106 4.5 9 4.5ZM7.5 7.5C7.5 9.20194 8.11366 9.75 9 9.75C9.88328 9.75 10.5 9.22379 10.5 7.65C10.5 6.71281 9.91174 6 9 6C8.0503 6 7.5 6.61187 7.5 7.5Z"
      fill="#BFBFBF"
    />
  </svg>
);

export const PurpleGift = () => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.49704 4.83268C3.16883 4.3855 3 3.83506 3 3.16602C3 1.84692 4.19035 0.666016 6 0.666016C7.81199 0.666016 9.27327 1.67737 10 3.26087C10.7267 1.67737 12.188 0.666016 14 0.666016C15.8096 0.666016 17 1.84692 17 3.16602C17 3.83506 16.8312 4.3855 16.503 4.83268H18C19.1046 4.83268 20 5.57887 20 6.49935V8.16602C20 9.08649 19.1046 9.83268 18 9.83268V15.666C18 16.5865 17.1046 17.3327 16 17.3327H4C2.89543 17.3327 2 16.5865 2 15.666V9.83268C0.89543 9.83268 0 9.08649 0 8.16602V6.49935C0 5.57887 0.89543 4.83268 2 4.83268H3.49704ZM9 6.49935H2V8.16602H9V6.49935ZM18 8.16602H11V6.49935H18V8.16602ZM9 15.666V9.83268H4V15.666H9ZM16 15.666H11V9.83268H16V15.666ZM6 2.33268C5.37965 2.33268 5 2.70932 5 3.16602C5 4.21037 6.017 4.70695 8.42942 4.81142C8.1613 3.25902 7.16218 2.33268 6 2.33268ZM11.5 4.81142C11.7681 3.25902 12.7672 2.33268 13.9294 2.33268C14.5498 2.33268 14.9294 2.70932 14.9294 3.16602C14.9294 4.21037 13.9124 4.70695 11.5 4.81142Z"
      fill="#675BF5"
    />
  </svg>
);
export const SubscriptionIcon = () => (
  <svg
    width="18"
    height="13"
    viewBox="0 0 18 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.11364 0.25H15.8864C16.6395 0.25 17.25 0.921573 17.25 1.75V10.75C17.25 11.5784 16.6395 12.25 15.8864 12.25H2.11364C1.36052 12.25 0.75 11.5784 0.75 10.75V1.75C0.75 0.921573 1.36052 0.25 2.11364 0.25ZM2.25 5.5V10.75H15.75V5.5H2.25ZM2.25 4H15.75V1.75H2.25V4Z"
      fill="#BFBFBF"
    />
  </svg>
);

export const InvoiceIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.5 14C0.5 14.8284 1.17157 15.5 2 15.5H12.0607L15.5 12.0607V2C15.5 1.17157 14.8284 0.5 14 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V14ZM2 2H14V10.25H11.75C10.9216 10.25 10.25 10.9216 10.25 11.75V14H2V2ZM11.75 11.75H13.6893L11.75 13.6893V11.75ZM4.25 10.25V11.75H8.75V10.25H4.25ZM4.25 8.75V7.25H11.75V8.75H4.25ZM4.25 4.25V5.75H11.75V4.25H4.25Z"
      fill="#BFBFBF"
    />
  </svg>
);

export const IconCheckCircle = () => (
  <svg
    width="116"
    height="116"
    viewBox="0 0 116 116"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58 0C25.9939 0 0 25.9938 0 58C0 90.0062 25.9939 116 58 116C90.0061 116 116 90.0062 116 58C116 25.9938 90.0061 0 58 0ZM58 4.46154C87.5949 4.46154 111.538 28.4051 111.538 58C111.538 87.5949 87.5949 111.538 58 111.538C28.4051 111.538 4.46154 87.5949 4.46154 58C4.46154 28.4051 28.4051 4.46154 58 4.46154ZM82.5559 43.0469C82.0522 43.0485 81.5639 43.2205 81.1704 43.5349L47.3341 69.6418L35.2392 54.68C35.0618 54.4343 34.8363 54.2272 34.5763 54.0716C34.3163 53.9159 34.0273 53.8148 33.727 53.7745C33.4267 53.7341 33.1213 53.7554 32.8294 53.837C32.5376 53.9186 32.2654 54.0588 32.0295 54.249C31.7937 54.4393 31.599 54.6756 31.4575 54.9435C31.3159 55.2115 31.2304 55.5055 31.2063 55.8075C31.1821 56.1096 31.2197 56.4134 31.3168 56.7005C31.4139 56.9875 31.5684 57.2518 31.771 57.4772L46.6022 75.8462L83.9065 47.064C84.2825 46.7826 84.5602 46.3897 84.6998 45.9414C84.8395 45.493 84.8341 45.012 84.6845 44.5668C84.5348 44.1217 84.2485 43.7351 83.8663 43.4622C83.4841 43.1893 83.0255 43.0439 82.5559 43.0469Z"
      fill="#52C41A"
    />
  </svg>
);

export const PDFIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.33926 10.0969L9.34453 10.0723C9.44648 9.65215 9.5748 9.12832 9.47461 8.65371C9.40781 8.2793 9.13184 8.1334 8.89629 8.12285C8.61855 8.11055 8.3707 8.26875 8.30918 8.49902C8.19316 8.9209 8.29687 9.49746 8.48672 10.2322C8.24766 10.8018 7.86621 11.6297 7.58672 12.1219C7.06641 12.3908 6.36855 12.8057 6.26484 13.3295C6.24375 13.4262 6.26836 13.5492 6.32637 13.66C6.39141 13.783 6.49512 13.8779 6.61641 13.9236C6.66914 13.943 6.73242 13.9588 6.80625 13.9588C7.11563 13.9588 7.6166 13.7092 8.28457 12.5631C8.38652 12.5297 8.49199 12.4945 8.59395 12.4594C9.07207 12.2977 9.56777 12.1289 10.016 12.0533C10.5117 12.3188 11.076 12.4893 11.4592 12.4893C11.8389 12.4893 11.9883 12.2643 12.0445 12.1289C12.143 11.8916 12.0955 11.5928 11.9355 11.4328C11.7035 11.2043 11.1393 11.1445 10.2604 11.2535C9.82793 10.9898 9.54492 10.6313 9.33926 10.0969ZM7.41094 12.767C7.1666 13.1221 6.98203 13.2996 6.88184 13.377C6.99961 13.1607 7.22988 12.9322 7.41094 12.767ZM8.95078 8.62734C9.04219 8.78379 9.02988 9.25664 8.95957 9.4957C8.87344 9.1459 8.86113 8.6502 8.91211 8.59219C8.92617 8.59395 8.93848 8.60449 8.95078 8.62734ZM8.92266 10.7455C9.11074 11.0707 9.34805 11.3502 9.60996 11.5576C9.23027 11.6438 8.88398 11.7861 8.57461 11.9127C8.50078 11.9426 8.42871 11.9725 8.3584 12.0006C8.59219 11.577 8.7873 11.0971 8.92266 10.7455V10.7455ZM11.6578 11.8969C11.6596 11.9004 11.6613 11.9057 11.6508 11.9127H11.6473L11.6438 11.918C11.6297 11.9268 11.4855 12.0111 10.865 11.7668C11.5787 11.7334 11.6561 11.8951 11.6578 11.8969V11.8969ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305V5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z"
      fill="#675BF5"
    />
  </svg>
);

export const TrashIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.27327 0H14.7406C15.9312 0 16.8964 0.89543 16.8964 2V3H20.1301C21.3207 3 22.2859 3.89543 22.2859 5V7C22.2859 8.10457 21.3207 9 20.1301 9H20.0437L19.0522 20C19.0522 21.1046 18.087 22 16.8964 22H6.11749C4.92688 22 3.9617 21.1046 3.96543 20.083L2.9699 9H2.88381C1.6932 9 0.728027 8.10457 0.728027 7V5C0.728027 3.89543 1.6932 3 2.88381 3H6.11749V2C6.11749 0.89543 7.08267 0 8.27327 0ZM2.88381 5H6.11749H16.8964H20.1301V7H2.88381V5ZM5.13282 9H17.8807L16.9001 19.917L16.8964 20H6.11749L5.13282 9ZM14.7406 2V3H8.27327V2H14.7406Z"
      fill="#675BF5"
    />
  </svg>
);

export const StarIcon = () => (
  <svg
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9994 19.1296L4.79339 22.918L6.16961 14.894L0.339844 9.21138L8.39638 8.04069L11.9994 0.740234L15.6024 8.04069L23.6589 9.21138L17.8291 14.894L19.2054 22.918L11.9994 19.1296Z"
      fill="#675BF5"
    />
  </svg>
);

export const ShadesIcon = () => (
  <svg
    width="24"
    height="10"
    viewBox="0 0 24 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 5C0.447715 5 0 4.55228 0 4C0 3.44772 0.447715 3 1 3H1.41604C2.1876 1.2341 3.94968 0 6 0C7.8244 0 9.42059 0.977119 10.2938 2.43658C10.7845 2.15804 11.3765 2 12 2C12.6235 2 13.2155 2.15804 13.7062 2.43658C14.5794 0.977119 16.1756 0 18 0C20.0503 0 21.8124 1.2341 22.584 3H23C23.5523 3 24 3.44772 24 4C24 4.55228 23.5523 5 23 5C23 7.76142 20.7614 10 18 10C15.2386 10 13 7.76142 13 5C13 4.83125 13.0084 4.66445 13.0247 4.5H13C13 4.29657 12.6046 4 12 4C11.3954 4 11 4.29657 11 4.5H10.9753C10.9916 4.66445 11 4.83125 11 5C11 7.76142 8.76142 10 6 10C3.23858 10 1 7.76142 1 5ZM6 8C7.65685 8 9 6.65685 9 5C9 3.34315 7.65685 2 6 2C4.34315 2 3 3.34315 3 5C3 6.65685 4.34315 8 6 8ZM21 5C21 6.65685 19.6569 8 18 8C16.3431 8 15 6.65685 15 5C15 3.34315 16.3431 2 18 2C19.6569 2 21 3.34315 21 5Z"
      fill="#8C8C8C"
    />
  </svg>
);
